/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Button, Typography, Icon, Dialog, DialogContent, IconButton, TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import SendIcon from '../../assets/img/send.png';
import { notificationDialogStyle } from '../../css/style';
import {
  NOTIFICATION_TITLE_MAX_LENGTH, NOTIFICATION_BODY_MAX_LENGTH,
} from '../../data/Constants';

const styles = notificationDialogStyle();

const PushNotificationDialog = (props) => {
  const {
    isDialogOpen,
    dialogHeight,
    onCloseDialog,
    dialogButtonText,
    onClickNextInDialog,
    onChangeNotification,
    notificationBodyLength,
    notificationTitleLength,
    isDialogWritingMessage,
    dialogContent,
  } = props;
  return (
    <Dialog
      maxWidth="xl"
      open={isDialogOpen}
      onClose={() => onCloseDialog()}
    >
      <DialogContent style={{ ...styles.notificationDialogContainer, height: dialogHeight }}>
        <IconButton
          style={styles.closeButton}
          onClick={() => onCloseDialog()}
        >
          <Icon>close</Icon>
        </IconButton>
        <img
          src={SendIcon}
          alt="Delete_Icon"
          style={styles.dialogImage}
        />
        <Typography style={styles.dialogTitle}>
          SEND PUSH NOTIFICATION
        </Typography>
        {
          isDialogWritingMessage
            ? (
              <div style={styles.dialogContentContainer}>
                <Typography style={styles.dialogSubTitle}>
                  Write the message below:
                </Typography>
                <TextField
                  autoFocus
                  placeholder="Message Title"
                  style={styles.notificationTitleTextBox}
                  inputProps={{
                    ...styles.notificationTitleInputProps,
                    maxLength: NOTIFICATION_TITLE_MAX_LENGTH,
                  }}
                  InputProps={{ disableUnderline: true }}
                  onChange={event => onChangeNotification(event, false)}
                />
                <div style={styles.maximumCharacterContainer}>
                  <Typography style={
                    notificationTitleLength < 42 ? styles.maximumCharacterText
                      : notificationTitleLength === 50 ? styles.maximumCharacterTextLimit
                        : styles.maximumCharacterTextCloseToLimit
                    }
                  >
                    {`${notificationTitleLength}/${NOTIFICATION_TITLE_MAX_LENGTH}`}
                  </Typography>
                </div>
                <TextField
                  multiline
                  autoFocus
                  placeholder="Write Message Here"
                  rows="6"
                  style={styles.notificationBodyTextBox}
                  inputProps={{
                    ...styles.notificationBodyInputProps,
                    maxLength: NOTIFICATION_BODY_MAX_LENGTH,
                  }}
                  InputProps={{ disableUnderline: true }}
                  onChange={event => onChangeNotification(event, true)}
                />
                <div style={styles.maximumCharacterContainer}>
                  <Typography style={
                    notificationBodyLength < 150 ? styles.maximumCharacterText
                      : notificationBodyLength === 178 ? styles.maximumCharacterTextLimit
                        : styles.maximumCharacterTextCloseToLimit
                    }
                  >
                    {`${notificationBodyLength}/${NOTIFICATION_BODY_MAX_LENGTH}`}
                  </Typography>
                </div>
              </div>
            )
            : (
              dialogContent
            )
        }
        {
          dialogButtonText
          && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Button
                style={styles.confirmButton}
                onClick={event => onClickNextInDialog(event)}
              >
                {dialogButtonText}
              </Button>
              <Typography
                style={styles.cancelText}
                onClick={() => onCloseDialog()}
              >
                cancel
              </Typography>
            </div>
          )
        }
      </DialogContent>
    </Dialog>
  );
};

PushNotificationDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func.isRequired,
  onClickNextInDialog: PropTypes.func.isRequired,
  dialogHeight: PropTypes.string.isRequired,
  dialogButtonText: PropTypes.string.isRequired,
  dialogContent: PropTypes.object.isRequired,
  notificationTitleLength: PropTypes.number.isRequired,
  notificationBodyLength: PropTypes.number.isRequired,
  onChangeNotification: PropTypes.func.isRequired,
  isDialogWritingMessage: PropTypes.bool.isRequired,
};

export default PushNotificationDialog;
